import { Component } from '@theme/component';
import { scrollIntoView } from '@theme/scrolling';

/**
 * @typedef {Object} MegaMenuBrands
 */

/**
 * A custom mega menu brands element
 *
 * @extends {Component}
 */

class MegaMenuBrands extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#handleSkipLinks();
    this.#handleTwoColumnLayout();
    this.#setInitialActiveLetter();
    
    // Listen for when parent section finishes hydrating
    const section = this.closest('.shopify-section');
    if (section) {
      const observer = new MutationObserver(() => {
        if (section.dataset.hydrated === 'true') {
          this.#handleTwoColumnLayout();
          observer.disconnect();
        }
      });
      
      observer.observe(section, {
        attributes: true,
        attributeFilter: ['data-hydrated']
      });
    }
  }

  updatedCallback() {
    super.updatedCallback();
    this.#handleTwoColumnLayout();
  }

  #setInitialActiveLetter = () => {
    let jumpLinks = this.querySelectorAll('.nj-mega-menu-brands__letter button:not(:disabled)');
    jumpLinks[0].classList.add('active');
  }

  #removeActiveClasses = () => {
    let activeButtons = this.querySelectorAll('.nj-mega-menu-brands__letter button.active');
    activeButtons.forEach(activeButton =>
      activeButton.classList.remove('active')
    );
  }

  #handleSkipLinks = () => {
    let jumpLinks = this.querySelectorAll('.nj-mega-menu-brands__letter button[data-index]');
    
    jumpLinks.forEach(link =>
      link.addEventListener('click', () => this.#scrollToColumn(link.dataset.index))
    );
  }
  
  #scrollToColumn = (index) => {
    /* Mark this letter as clicked */
    this.#removeActiveClasses();
    let clickedButton = this.querySelector(`.nj-mega-menu-brands__letter button[data-index="${index}"]`);
    clickedButton.classList.add('active');
    
    let container = this.querySelector('.nj-mega-menu-brands__columns');
    let desiredColumn = this.querySelector(`.nj-mega-menu-brands__column[data-index="${index}"]`);
    
    /* Scroll to column */
    scrollIntoView(desiredColumn, {
      ancestor: container,
      behavior: 'instant',
      block: 'start',
      inline: 'start',
    });
  }

  #handleTwoColumnLayout = () => {
    let columns = this.querySelectorAll('.nj-mega-menu-brands__column');
    
    columns.forEach(column => {
      let ul = column.querySelector('ul');
      if (!ul) return;
      
      let itemCount = ul.querySelectorAll('li').length;
      
      if (itemCount > 30) {
        column.classList.add('four-column');
      } else if (itemCount > 20) {
        column.classList.add('three-column');
      } else if (itemCount > 10) {
        column.classList.add('two-column');
      }
    });
  }
}

if (!customElements.get('nj-mega-menu-brands')) {
  customElements.define('nj-mega-menu-brands', MegaMenuBrands);
}
